function WhyUs() {
    return ( 
        <>
        <section className="why-us">
            <div className="container">
                <div className="row">
                    <div className="col-12 col-md-6 col-lg-3 card-outer">
                        <div className="card-inner">
                            <div className="icon">
                                💻
                            </div>
                            <div className="card-heading">
                                Content Moderation
                            </div>
                            <div className="card-body">
                                We're here to help you craft your content and stand by your side with every step.
                            </div>
                        </div>
                    </div>

                    <div className="col-12 col-md-6 col-lg-3 card-outer">
                        <div className="card-inner">
                            <div className="icon">
                                🏆
                            </div>
                            <div className="card-heading">
                                Marketing
                            </div>
                            <div className="card-body">
                                TikTok, Instagram, Reddit, X - we have strategies and solutions for every traffic channel out there.
                            </div>
                        </div>
                    </div>

                    <div className="col-12 col-md-6 col-lg-3 card-outer">
                        <div className="card-inner">
                            <div className="icon">
                                😘
                            </div>
                            <div className="card-heading">
                                Sexting
                            </div>
                            <div className="card-body">
                                Our worldwide team, boasting over 12 chatters, stands ready to transform your content into revenue.
                            </div>
                        </div>
                    </div>

                    <div className="col-12 col-md-6 col-lg-3 card-outer">
                        <div className="card-inner">
                            <div className="icon">
                                📈
                            </div>
                            <div className="card-heading">
                                Scaling
                            </div>
                            <div className="card-body">
                                We elevate your account from the ground up, steering it towards its highest earning potential.
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        </>
     );
}

export default WhyUs;